import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCrown } from "react-icons/fa";

const UpgradeButton = ({ className = "", size = "sm" }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate("/plan-select", { state: { isUpgrade: true } });
  };

  const sizeClasses = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-6 py-3 text-lg"
  };

  return (
    <button
      onClick={handleUpgrade}
      className={`${sizeClasses[size]} bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center gap-2 ${className}`}
    >
      <FaCrown className="text-yellow-600" />
      Upgrade Plan
    </button>
  );
};

export default UpgradeButton;
